import { useMemo } from 'react'

import {
  useSignInWithAppleMutation,
  useSignUpWithAppleMutation,
  useConnectWithAppleMutation,
} from '~/store/api'
import { APPLE_AUTH_TYPES } from '~/constants'

const useAppleAuthMethod = type => {
  const [signInWithApple, signInWithAppleApiResult] = useSignInWithAppleMutation()
  const [signUpWithApple, signUpWithAppleApiResult] = useSignUpWithAppleMutation()
  const [connectWithApple, connectWithAppleApiResult] = useConnectWithAppleMutation()

  const authMethod = useMemo(() => {
    switch (type) {
      case APPLE_AUTH_TYPES.SIGN_UP:
        return signUpWithApple
      case APPLE_AUTH_TYPES.SIGN_IN:
        return signInWithApple
      case APPLE_AUTH_TYPES.CONNECT:
        return connectWithApple
      default:
        return () => {}
    }
  }, [type, connectWithApple, signInWithApple, signUpWithApple])

  const authMethodApiResult = useMemo(() => {
    switch (type) {
      case APPLE_AUTH_TYPES.SIGN_UP:
        return signUpWithAppleApiResult
      case APPLE_AUTH_TYPES.SIGN_IN:
        return signInWithAppleApiResult
      case APPLE_AUTH_TYPES.CONNECT:
        return connectWithAppleApiResult
      default:
        return {}
    }
  }, [type, signInWithAppleApiResult, signUpWithAppleApiResult, connectWithAppleApiResult])

  return {
    authMethod,
    authMethodApiResult
  }
}

export default useAppleAuthMethod
